@if (skeleton()) {
	<span tuiAvatar [size]="size()" [tuiSkeleton]="true"></span>

	<div class="flex-auto">
		<p [tuiSkeleton]="6"></p>
		<small [tuiSkeleton]="4"></small>
	</div>
} @else {
	@if (name(); as name) {
		<span
			[tuiAvatar]="name | initials"
			[size]="size()"
			appearance="primary"
		></span>

		<div class="flex-auto">
			<p>{{ name }}</p>

			@if (email(); as email) {
				<small>{{ email }}</small>
			}
		</div>
	} @else if (email()) {
		<span
			tuiAvatar="@tui.mail-plus"
			[size]="size()"
			appearance="primary"
		></span>

		<div class="flex-auto">
			<p>{{ email() }}</p>
		</div>
	}
}

<ng-content />
